<script>
import { uiState } from "@app/store/uiStore.svelte.js";
import Menu from "../menu/Menu.svelte";
import MenuItem from "../menu/MenuItem.svelte";
import SubMenu from "../menu/SubMenu.svelte";
import * as m from "@app/paraglide/messages.js";

/** @type {{ nested?: boolean }} */
let { nested = false } = $props();

function updateLayout(layout) {
    localStorage.setItem("cc-workspace-default", layout);
    uiState.timeline = false;
    let source;
    if (player && player.src) {
        source = player.src;
    }

    uiState.layout = layout;

    setTimeout(() => {
        uiState.timeline = true;
    }, 2000);

    if (source && source.src) {
        player.src = "";
        setTimeout(() => {
            player.src = source;
        }, 250);
    }
}
</script>

{#snippet items()}
    <MenuItem
        label={m.workspace_default()}
        icon="bi-layout-sidebar-inset-reverse"
        id="workspace-default"
        checked={uiState.layout === "default"}
        onSelect={() => updateLayout("default")} />
    <MenuItem
        label={m.workspace_default_reverse()}
        icon="bi-layout-sidebar-inset"
        id="workspace-reverse"
        checked={uiState.layout === "reverse"}
        onSelect={() => updateLayout("reverse")} />
    <MenuItem
        label={m.workspace_vertical_stack()}
        icon="bi-layout-three-columns"
        id="workspace-vertical"
        checked={uiState.layout === "vertical"}
        onSelect={() => updateLayout("vertical")} />
    <MenuItem
        label={m.workspace_ultrawide()}
        icon="bi-display"
        id="workspace-ultrawide"
        checked={uiState.layout === "ultrawide"}
        onSelect={() => updateLayout("ultrawide")} />
{/snippet}

{#if nested}
    <SubMenu label={m.workspaces()} icon="bi-layout-sidebar-inset-reverse">
        {@render items()}
    </SubMenu>
{:else}
    <Menu id="workspaces" label={m.workspaces()}>
        {@render items()}
    </Menu>
{/if}
